/* Top Racing Point - ricerca cerchi.
   Legge i tag dei prodotti della collezione (/collections/<handle>?view=trpauto&page=N):
   "marca evo corse", "diametro 15", "canale 8", "pcd 4x108", "et 20", "et negativo 7".
   Le tendine mostrano solo i valori che esistono davvero, con il numero di cerchi.
   Il filtro usa i tag reali: /collections/cerchi/marca-oz-racing+diametro-15+canale-8+pcd-4x108+et-20 (AND, senza app).
   Tendine indipendenti (21/10/2026): ognuna mostra i valori compatibili con le altre scelte, si parte da qualsiasi tendina.
   Tendina "Marchio" (20/10/2026): c'e' solo sulla pagina Cerchi; e' facoltativa (si puo partire dal diametro).
   Sulle pagine dei marchi e dei modelli (cerchi-...) le tendine leggono solo i cerchi di quella pagina.

   Scheda "auto da gara", due tipi di voci:
   1) AUTO qui sotto [marca, modello, foratura]: mostra tutti i cerchi con quella foratura.
   2) Auto da gara con cerchi dedicati: si creano DA SOLE dal tag del prodotto
      "gara Marca | Modello"  (es. "gara Skoda | Fabia Rally2 / R5", "gara Formula | Gloria").
      Mostra solo i cerchi con quel tag. Per aggiungere un'auto basta mettere il tag ai cerchi. */
(function(){
  var AUTO = [
    ['Abarth','500 / 595 / 695','4x98'],
    ['Abarth','Grande Punto','4x100'],
    ['Abarth','124 Rally','4x100'],
    ['Fiat','Cinquecento / Seicento','4x98'],
    ['BMW','E30 (non M3)','4x100'],
    ['BMW','E30 M3 / Gr.A','5x120'],
    ['BMW','Serie 3 E36 / E46','5x120'],
    ['BMW','M3 E46 / E9x','5x120'],
    ['Citroen','Saxo / S1600 / Challenge / N2','4x108'],
    ['Citroen','C2 / C2 R2 / R2 Max / Challenge','4x108'],
    ['Citroen','DS3 R3','4x108'],
    ['Ford','Fiesta ST / R2','4x108'],
    ['Ford','Escort RS Cosworth','4x108'],
    ['Ford','Focus RS','5x108'],
    ['Honda','Civic EG / EK','4x100'],
    ['Honda','Civic EP3','5x114.3'],
    ['Honda','Civic FK2 / FK8','5x120'],
    ['Honda','Integra DC2','4x100'],
    ['Honda','S2000','5x114.3'],
    ['Lancia','Delta Integrale','5x98'],
    ['Lancia','Ypsilon Rally4','4x108'],
    ['Mazda','MX-5 NA / NB','4x100'],
    ['Mazda','MX-5 NC','5x114.3'],
    ['Mazda','MX-5 ND','4x100'],
    ['Mitsubishi','Lancer Evo I - III','4x114.3'],
    ['Mitsubishi','Lancer Evo IV - IX / Gr.N','5x114.3'],
    ['Mitsubishi','Lancer Evo X','5x114.3'],
    ['Nissan','200SX S13','4x114.3'],
    ['Nissan','200SX S14 / S15','5x114.3'],
    ['Nissan','350Z','5x114.3'],
    ['Peugeot','106 / 106 Maxi','4x108'],
    ['Peugeot','205 / 309','4x108'],
    ['Peugeot','206 / 207','4x108'],
    ['Peugeot','208 R2 / Rally4','4x108'],
    ['Peugeot','306 / 306 Kit Car','4x108'],
    ['Porsche','911 Classic (anni 60-80)','5x130'],
    ['Porsche','911 996 / 997','5x130'],
    ['Porsche','Cayman / Boxster','5x130'],
    ['Renault','Clio 2 RS / Williams / S1600','4x100'],
    ['Renault','Clio 3 RS','5x114.3'],
    ['Renault','Clio 4 RS','5x114.3'],
    ['Renault','Clio Rally5','4x100'],
    ['Renault','Clio Rally3','4x100'],
    ['Renault','Twingo R1 / R2','4x100'],
    ['Subaru','Impreza GC / GD (fino al 2005)','5x100'],
    ['Subaru','Impreza STI dal 2005','5x114.3'],
    ['Toyota','GT86 / Subaru BRZ','5x100'],
    ['Toyota','GR Yaris','5x114.3'],
    ['Volkswagen','Golf 1 / 2','4x100'],
    ['Volkswagen','Golf 4','5x100'],
    ['Volkswagen','Golf 5 e successive','5x112'],
    ['Volkswagen','Polo GTI / R5','5x100']
  ];
  var MARCHE = { citroen:'Citro'+String.fromCharCode(235)+'n', bmw:'BMW', skoda:'Skoda' };
  var PARALLELE = 6;
  var NOMI = { b:'Marchio', d:'Diametro', c:'Canale', p:'Foratura', e:'ET' };
  // marchi: tag "marca <nome>" -> nome mostrato
  var NOMI_MARCA = { 'evo corse':'Evo Corse', 'evo':'Evo Corse', 'oz racing':'OZ Racing', 'oz':'OZ Racing', 'braid':'Braid', 'maxilite':'Maxilite', 'racingline':'RacingLine', 'mmx':'MMX', 'bbs':'BBS', 'msw':'MSW', 'tsw':'TSW', 'japan racing':'Japan Racing', 'wedssport':'WedsSport', '6performance':'6Performance', 'fifteen52':'Fifteen52', '7twenty':'7Twenty', 'american racing':'American Racing' };
  NOMI_MARCA['59'+String.fromCharCode(176)+'north']='59'+String.fromCharCode(176)+'North';
  NOMI_MARCA['str'+String.fromCharCode(246)+'m']='Str'+String.fromCharCode(246)+'m';
  function nomeMarca(v){ return NOMI_MARCA[v] || v.replace(/(^|\s)(\S)/g,function(x,a,b){ return a+b.toUpperCase(); }); }

  function ready(fn){ if(document.readyState!=='loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function handleize(t){ return String(t).toLowerCase().normalize('NFD').split('').filter(function(ch){ var k=ch.charCodeAt(0); return k<768 || k>879; }).join('').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function ordina(k){ return function(a,b){ if(k==='b') return nomeMarca(a).localeCompare(nomeMarca(b),'it'); if(k==='p'){ var x=a.split('x'), y=b.split('x'); return (+x[0]-y[0]) || (+x[1]-y[1]); } return parseFloat(a)-parseFloat(b); }; }
  function marca(m){ var h=handleize(m); return MARCHE[h] || m; }
  function etichetta(k,v){
    if(k==='b') return nomeMarca(v);
    if(k==='d') return v+'"';
    if(k==='c') return v+'"';
    if(k==='e') return 'ET '+v;
    return v;
  }
  // valore -> tag reale
  function tagDi(k,v){
    if(k==='d') return 'diametro '+v;
    if(k==='c') return 'canale '+v;
    if(k==='p') return 'pcd '+v;
    if(k==='e') return v.charAt(0)==='-' ? 'et negativo '+v.slice(1) : 'et '+v;
    if(k==='g') return v;
    if(k==='b') return 'marca '+v;
  }

  // tag dei prodotti -> {d:{}, c:{}, p:{}, e:{}, g:{}, b:{}}  (g = tag "gara ..." originali)
  function leggi(prodotti){
    var out=[];
    (prodotti||[]).forEach(function(r){
      var m={d:{},c:{},p:{},e:{},g:{},b:{}}, ok=false;
      (r[1]||[]).forEach(function(orig){
        var t=String(orig).toLowerCase().trim(), x;
        if((x=/^diametro (\d+(?:\.\d+)?)$/.exec(t))){ m.d[x[1]]=1; ok=true; }
        else if((x=/^canale (\d+(?:\.\d+)?)$/.exec(t))){ m.c[x[1]]=1; ok=true; }
        else if((x=/^pcd (\d+x\d+(?:\.\d+)?)$/.exec(t))){ m.p[x[1]]=1; ok=true; }
        else if((x=/^et negativo (\d+(?:\.\d+)?)$/.exec(t))){ m.e['-'+x[1]]=1; ok=true; }
        else if((x=/^et (\d+(?:\.\d+)?)$/.exec(t))){ m.e[x[1]]=1; ok=true; }
        else if(/^gara\s+\S/.test(t)){ m.g[String(orig).trim()]=1; ok=true; }
        else if((x=/^marca (.+)$/.exec(t))){ m.b[x[1]]=1; }
      });
      if(ok) out.push(m);
    });
    return out;
  }
  function combacia(m,scelte){ for(var k in scelte){ if(scelte[k] && !m[k][scelte[k]]) return false; } return true; }
  function conta(dati,scelte){ var n=0; dati.forEach(function(m){ if(combacia(m,scelte)) n++; }); return n; }
  // valori disponibili per la chiave k dati i filtri precedenti, con conteggio
  function valori(dati,k,prima){
    var c={};
    dati.forEach(function(m){ if(combacia(m,prima)) Object.keys(m[k]).forEach(function(v){ c[v]=(c[v]||0)+1; }); });
    return Object.keys(c).sort(ordina(k)).map(function(v){ return [v,c[v]]; });
  }
  // elenco auto: voci per foratura (AUTO) + auto da gara dai tag "gara Marca | Modello"
  function elencoAuto(dati){
    var lista=[];
    AUTO.forEach(function(a){
      var n=conta(dati,{p:a[2]});
      if(n) lista.push({id:handleize(a[0]+' '+a[1]), marca:marca(a[0]), modello:a[1], filtro:{p:a[2]}, nota:a[2]});
    });
    var visti={};
    dati.forEach(function(m){ Object.keys(m.g).forEach(function(t){ visti[t]=1; }); });
    Object.keys(visti).forEach(function(t){
      var resto=t.replace(/^gara\s+/i,''), mm, mo;
      if(resto.indexOf('|')>-1){ mm=resto.split('|')[0].trim(); mo=resto.split('|').slice(1).join('|').trim(); }
      else { mm=resto.split(' ')[0]; mo=resto.split(' ').slice(1).join(' '); }
      lista.push({id:handleize(t), marca:marca(mm), modello:mo, filtro:{g:t}, nota:'cerchi dedicati', gara:true});
    });
    return lista;
  }

  function carica(base, fatto){
    var chiave='trpcerchi4:'+base, cache=null;
    try{ cache=JSON.parse(sessionStorage.getItem(chiave)||'null'); }catch(e){}
    if(cache && cache.t && (Date.now()-cache.t)<3600000){ fatto(cache.p); return; }
    function pagina(n){
      return fetch(base+'?view=trpauto&page='+n,{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(txt){ return JSON.parse(txt); });
    }
    pagina(1).then(function(d1){
      var totale=Math.min(d1.pagine||1, 60), risultati=[d1.p||[]], prossima=2, attive=0, finito=false;
      function fine(){
        if(finito) return; finito=true;
        var tutti=[]; risultati.forEach(function(r){ if(r) tutti=tutti.concat(r.map(function(x){ return [0,x[1]]; })); });
        try{ sessionStorage.setItem(chiave,JSON.stringify({t:Date.now(),p:tutti})); }catch(e){}
        fatto(tutti);
      }
      function avvia(){
        if(prossima>totale && attive===0){ fine(); return; }
        while(attive<PARALLELE && prossima<=totale){
          (function(n){
            attive++;
            pagina(n).then(function(d){ risultati[n-1]=d.p||[]; }).catch(function(){ risultati[n-1]=[]; }).then(function(){ attive--; avvia(); });
          })(prossima++);
        }
      }
      avvia();
    }).catch(function(){ fatto([]); });
  }

  function opzione(v,l){ var o=document.createElement('option'); o.value=v; o.textContent=l; return o; }

  if(typeof document!=='undefined') ready(function(){
    var root=document.querySelector('[data-trp-cerchi]'); if(!root) return;
    var base=(root.getAttribute('data-collection-url')||'').replace(/\/$/,'');
    var tabs=[].slice.call(root.querySelectorAll('[data-trp-tab]'));
    var pannelli={}; [].slice.call(root.querySelectorAll('[data-trp-panel]')).forEach(function(p){ pannelli[p.getAttribute('data-trp-panel')]=p; });
    var riepilogo=root.querySelector('[data-trp-riepilogo]');
    var conMarchio=!!pannelli.misura.querySelector('[data-trp-sel="b"]');
    var ORDINE={ misura: conMarchio ? ['d','c','p','e','b'] : ['d','c','p','e'], auto:['a','d','c','e'] };

    function sel(pan,k){ return pannelli[pan].querySelector('[data-trp-sel="'+k+'"]'); }
    function mostraScheda(nome){
      tabs.forEach(function(t){ var on=t.getAttribute('data-trp-tab')===nome; t.classList.toggle('is-active',on); t.setAttribute('aria-selected',on?'true':'false'); });
      Object.keys(pannelli).forEach(function(k){ pannelli[k].hidden = (k!==nome); });
    }
    tabs.forEach(function(t){ t.addEventListener('click',function(){ mostraScheda(t.getAttribute('data-trp-tab')); }); });
    [].slice.call(root.querySelectorAll('[data-trp-azzera]')).forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); window.location.assign(base); }); });

    // pagina-guida di Cerchi: pulsante "Vedi tutti i cerchi"
    var vediTutti=document.querySelector('[data-trp-vedi-tutti]');
    if(vediTutti) vediTutti.addEventListener('click',function(){
      document.documentElement.classList.remove('trp-cerchi-home');
      var c=document.getElementById('Collection'); if(c) c.scrollIntoView({behavior:'smooth'});
    });
    function esc(t){ return String(t).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
    // blocchi diametro e foratura della pagina-guida (conteggi veri dai tag)
    function riempiGuida(tutti){
      var bd=document.querySelector('[data-trp-guida-d]'), bp=document.querySelector('[data-trp-guida-p]');
      if(bd){
        bd.innerHTML=valori(tutti,'d',{}).filter(function(x){ return x[1]>=3; }).map(function(x){
          return '<li><a class="trp-cg__pillola" href="'+base+'/'+handleize(tagDi('d',x[0]))+'"><strong>'+esc(x[0])+'"</strong><span>'+x[1]+' cerchi</span></a></li>';
        }).join('');
      }
      if(bp){
        var auto={}; AUTO.forEach(function(a){ (auto[a[2]]=auto[a[2]]||[]).push(marca(a[0])+' '+a[1]); });
        var lista=valori(tutti,'p',{}).filter(function(x){ return auto[x[0]] || x[1]>=40; });
        lista.sort(function(a,b){ return (!!auto[b[0]]-!!auto[a[0]]) || ordina('p')(a[0],b[0]); });
        bp.innerHTML=lista.map(function(x){
          var a=auto[x[0]]||[], corti=[];
          a.forEach(function(n){ var c=n.split(' / ')[0].replace(/\s*\(.*$/,''); if(corti.indexOf(c)<0) corti.push(c); });
          var testo=corti.slice(0,2).join(', ')+(corti.length>2?'…':'');
          return '<li><a class="trp-cg__pcdbox" href="'+base+'/'+handleize(tagDi('p',x[0]))+'" title="'+esc(a.length ? a.join(', ') : x[1]+' cerchi')+'"><strong>'+esc(x[0])+'</strong>'+(testo?'<span class="trp-cg__auto">'+esc(testo)+'</span>':'')+'<span class="trp-cg__num">'+x[1]+'</span></a></li>';
        }).join('');
      }
    }

    carica(base,function(prodotti){
      var tutti=leggi(prodotti);
      riempiGuida(tutti);
      // marchio nell'indirizzo (tag marca-...): con la tendina Marchio diventa la sua scelta
      var dopo=window.location.pathname.replace(/\/$/,'').split('/collections/')[1]||'';
      var pezzi=dopo.split('/').slice(1).join('/').split('+').filter(Boolean).map(decodeURIComponent);
      var marcaSel=null;
      valori(tutti,'b',{}).forEach(function(x){ if(pezzi.indexOf(handleize(tagDi('b',x[0])))>-1) marcaSel=x[0]; });
      var marcaUrl=marcaSel;
      if(conMarchio) marcaSel=null;
      var dati=marcaSel ? tutti.filter(function(m){ return m.b[marcaSel]; }) : tutti;
      var auto=elencoAuto(dati);
      var autoPer={}; auto.forEach(function(a){ autoPer[a.id]=a; });

      function filtroAuto(id){ var a=autoPer[id]; return a ? a.filtro : {}; }
      function scelte(pan){
        var s={};
        ORDINE[pan].forEach(function(k){
          var v=sel(pan,k).value;
          if(k==='a'){ var f=filtroAuto(v); for(var x in f) s[x]=f[x]; }
          else if(v) s[k]=v;
        });
        return s;
      }
      function riempiAuto(scelto){
        var s=sel('auto','a'); s.innerHTML=''; s.appendChild(opzione('','Seleziona l\'auto'));
        var gruppi={}, marche=[];
        auto.forEach(function(a){ if(!gruppi[a.marca]){ gruppi[a.marca]=[]; marche.push(a.marca); } gruppi[a.marca].push(a); });
        marche.sort(function(x,y){ if(x==='Formula') return 1; if(y==='Formula') return -1; return x.localeCompare(y,'it'); });
        marche.forEach(function(m){
          var g=document.createElement('optgroup'); g.label=m;
          gruppi[m].sort(function(x,y){ return x.modello.localeCompare(y.modello,'it',{numeric:true}); });
          gruppi[m].forEach(function(a){ g.appendChild(opzione(a.id, m+' '+a.modello+' ('+a.nota+')')); });
          s.appendChild(g);
        });
        s.value=scelto||'';
      }
      // ricostruisce le tendine (21/10/2026): ogni tendina mostra i valori compatibili con TUTTE le altre scelte,
      // cosi' si puo' partire da qualsiasi tendina (es. foratura 5x112 dalla pagina-guida) e poi scegliere le altre senza perderla.
      var TUTTI={ b:'Tutti i marchi', d:'Tutti i diametri', c:'Tutti i canali', p:'Tutte le forature', e:'Tutti gli ET' };
      function aggiorna(pan){
        var ord=ORDINE[pan], cur={}, autoF={};
        for(var giro=0; giro<2; giro++){
          cur={}; autoF={};
          ord.forEach(function(k){ var v=sel(pan,k).value; if(k==='a'){ autoF=filtroAuto(v); } else if(v){ cur[k]=v; } });
          ord.forEach(function(k){
            if(k==='a') return;
            var s=sel(pan,k), vecchio=s.value, prima={}, x;
            for(x in autoF) prima[x]=autoF[x];
            for(x in cur) if(x!==k) prima[x]=cur[x];
            var lista=valori(dati,k,prima);
            s.innerHTML=''; s.appendChild(opzione('', TUTTI[k]));
            lista.forEach(function(v){ s.appendChild(opzione(v[0], etichetta(k,v[0])+'  ('+v[1]+')')); });
            s.disabled=!lista.length;
            s.value = lista.some(function(v){ return v[0]===vecchio; }) ? vecchio : '';
            if(s.value) cur[k]=s.value; else delete cur[k];
          });
        }
        var tutte={}, y;
        for(y in autoF) tutte[y]=autoF[y];
        for(y in cur) tutte[y]=cur[y];
        var pul=pannelli[pan].querySelector('[data-trp-vai]'), n=conta(dati,tutte), vuoto=!Object.keys(tutte).length;
        pul.disabled=vuoto || !n;
        pul.querySelector('span').textContent = vuoto ? 'Mostra cerchi' : 'Mostra '+n+(n===1?' cerchio':' cerchi');
      }
      function indirizzo(pan){
        var s=scelte(pan), tags=[];
        if(marcaSel) tags.push(handleize(tagDi('b',marcaSel)));
        ['b','g','d','c','p','e'].forEach(function(k){ if(s[k]) tags.push(handleize(tagDi(k,s[k]))); });
        var qs=new URLSearchParams(window.location.search); qs.delete('page'); qs.delete('auto');
        var a=autoPer[sel('auto','a').value];
        if(pan==='auto' && a && !a.gara) qs.set('auto', a.id);
        var q=qs.toString();
        return base+(tags.length?'/'+tags.join('+'):'')+(q?'?'+q:'');
      }
      ['misura','auto'].forEach(function(pan){
        ORDINE[pan].forEach(function(k){ sel(pan,k).addEventListener('change',function(){ aggiorna(pan); }); });
        pannelli[pan].querySelector('[data-trp-vai]').addEventListener('click',function(){ window.location.assign(indirizzo(pan)); });
      });

      // Ripristina la scelta leggendo l'indirizzo (/collections/cerchi/<tag>+<tag>?auto=...)
      var attuali={};
      if(conMarchio && marcaUrl) attuali.b=marcaUrl;
      if(pezzi.length){
        ['d','c','p','e'].forEach(function(k){
          valori(dati,k,{}).forEach(function(x){ if(pezzi.indexOf(handleize(tagDi(k,x[0])))>-1) attuali[k]=x[0]; });
        });
      }
      var autoSel=null;
      auto.forEach(function(a){ if(a.gara && pezzi.indexOf(a.id)>-1) autoSel=a; });
      var autoUrl=new URLSearchParams(window.location.search).get('auto');
      if(!autoSel && autoUrl && autoPer[autoUrl] && (!attuali.p || attuali.p===autoPer[autoUrl].filtro.p)) autoSel=autoPer[autoUrl];
      if(autoSel){
        mostraScheda('auto'); riempiAuto(autoSel.id);
        aggiorna('auto');
        ['d','c','e'].forEach(function(k){ if(attuali[k]) sel('auto',k).value=attuali[k]; });
        aggiorna('auto'); aggiorna('misura');
      } else {
        riempiAuto('');
        aggiorna('misura');
        ORDINE.misura.forEach(function(k){ if(attuali[k]) sel('misura',k).value=attuali[k]; });
        aggiorna('misura');
        aggiorna('auto');
      }

      // Riepilogo sopra i risultati
      var marcaVista=marcaSel || attuali.b;
      if(Object.keys(attuali).length || autoSel || marcaSel){
        var parti=[], filtro={};
        if(marcaVista) parti.push('Marchio <strong>'+nomeMarca(marcaVista)+'</strong>');
        if(attuali.b) filtro.b=attuali.b;
        if(autoSel){ parti.push('<strong>'+autoSel.marca+' '+autoSel.modello+'</strong>'); for(var x in autoSel.filtro) filtro[x]=autoSel.filtro[x]; }
        ['d','c','p','e'].forEach(function(k){ if(attuali[k]){ filtro[k]=attuali[k]; if(!(autoSel && k==='p' && !autoSel.gara)) parti.push((k==='e'?'':NOMI[k]+' ')+'<strong>'+etichetta(k,attuali[k])+'</strong>'); } });
        if(autoSel && !autoSel.gara) parti.push('Foratura <strong>'+autoSel.filtro.p+'</strong>');
        var n=conta(dati,filtro);
        riepilogo.innerHTML='Stai vedendo: '+parti.join(' &middot; ')+' &mdash; <strong>'+n+(n===1?' cerchio':' cerchi')+'</strong>'+
          '<a href="'+base+'">Azzera ricerca</a>'+
          (n===0?'<span class="trp-cerchi__zero">Nessun cerchio con questa combinazione: prova a togliere l\'ET o il canale.</span>':'');
        riepilogo.hidden=false;
      }
    });
  });

  if(typeof module!=='undefined') module.exports={nomeMarca:nomeMarca, leggi:leggi, valori:valori, conta:conta, handleize:handleize, tagDi:tagDi, elencoAuto:elencoAuto, AUTO:AUTO};
})();
